import { render } from "./ListLinkDetail.vue?vue&type=template&id=51ec9f7a"
import script from "./ListLinkDetail.vue?vue&type=script&lang=js"
export * from "./ListLinkDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__